/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      $( '.team-member-page .projects' ).slick( {
        arrows: false,
        dots: false,
        variableWidth: true,
        slidesToShow: 2,
        infinite: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              variableWidth: false,
            },
          },
        ],
      } );

      $( '.team-member-page .projects' ).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
        let totalSlides;

        if ( window.innerWidth > 1023 ) {
          totalSlides = $( '.team-member-page .projects .project-wrapper' ).length - 1;
        } else {
          totalSlides = $( '.team-member-page .projects .project-wrapper' ).length;
        }
        const width = ( ( nextSlide + 1 ) / totalSlides ) * 100;
        $( this ).closest( '.team-member-page' ).find( '.progress-tracker' ).width( width + '%' );
      } );

      $( '.team-member-page .project-progress button' ).click( function() {
        $( '.team-member-page .projects' ).slick( 'slickGoTo', $( this ).attr( 'data-slide' ) );
      } );

      $( '.team-grid .image-wrapper' ).on( 'mouseenter', function( e ) {
        $( this ).find( '.learn-more' ).addClass( 'is-visible' );
      } ).on( 'mousemove', function( e ) {
        const tagWidth = $( this ).find( '.learn-more' ).outerWidth();
        $( this ).find( '.learn-more' ).css( {
          top: e.offsetY,
          left: e.offsetX - ( tagWidth / 2 ),
        } );
      } ).on( 'mouseleave', function() {
        $( this ).find( '.learn-more' ).removeClass( 'is-visible' );
      } );

      $( '.team-member-page .projects-wrapper.show-drag' ).on( 'mouseenter', function( e ) {
        $( this ).find( '.following-tooltip' ).addClass( 'is-visible' );
      } ).on( 'mousemove', function( e ) {
        const tagWidth = $( this ).find( '.following-tooltip' ).outerWidth();
        $( this ).find( '.following-tooltip' ).css( {
          top: e.pageY - this.offsetTop,
          left: ( e.pageX - this.offsetLeft ) - ( tagWidth / 2 ),
        } );
      } ).on( 'mouseleave', function() {
        $( this ).find( '.following-tooltip' ).removeClass( 'is-visible' );
      } );

      $( '.team__filter-button' ).on( 'click', function() {
        const dept = $( this ).data( 'department' );

        $( this ).toggleClass( 'is-active' );

        if ( $( this ).hasClass( 'is-active' ) ) {
          $( '.team__filter-button' ).not( this ).removeClass( 'is-active' );
          $( '.team-grid .team-member' ).addClass( 'hidden' );
          $( '.team-grid .team-member[data-department="' + dept + '"]' ).removeClass( 'hidden' );
        } else {
          $( '.team-grid .team-member' ).removeClass( 'hidden' );
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'team', COMPONENT );
} )( app );
